module.exports = __webpack_public_path__ + "static/media/bus-icon.364d2145.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/bus-icon.svg
// module id = 790
// module chunks = 0